import { Check, ChevronRight } from 'lucide-react';
import { createElement, forwardRef, type ButtonHTMLAttributes, type InputHTMLAttributes } from 'react';

import { getFinanceIcon } from './financeAppearance';

export function FinanceAppearancePicker({ icon, color, onClick }: { icon: string; color: string; onClick: () => void }) {
  return (
    <button type="button" className="appearance-picker" aria-label="Открыть выбор иконки и цвета" onClick={onClick}>
      <span style={{ background: color }}>{createElement(getFinanceIcon(icon), { size: 28 })}</span>
      <span><strong>Иконка и цвет</strong><small>Нажмите, чтобы изменить</small></span>
      <ChevronRight size={20} />
    </button>
  );
}

export const FinanceNameField = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(function FinanceNameField(props, ref) {
  return <label className="mobile-form-field"><span>Название</span><input {...props} ref={ref} /></label>;
});

export function FinanceSaveButton({ children, className = '', ...props }: ButtonHTMLAttributes<HTMLButtonElement>) {
  return <button type="submit" {...props} className={`operation-save finance-save ${className}`.trim()}><Check size={21} strokeWidth={3} />{children}</button>;
}
